<mat-toolbar class="bg-white">
    <span class="logo" style="cursor: pointer;" (click)="redirectToHome()"><img src="../assets/images/vassarDigital.png" alt="Vassar Digital" class="logo"></span>
    <span class="example-spacer"></span>
    <span class="app-logo" style="cursor: pointer;">
        <h4>{{applicationName}}</h4>
    </span>
    <span class="example-spacer"></span>
    <div class="buttons">
        <div [matMenuTriggerFor]="menu" class="profile">
            <div class="avatar">
                <h1>
                    {{userInfo?.username[0] | titlecase}}
                </h1>
            </div>
            <mat-icon>expand_more</mat-icon>
        </div>
        <mat-menu #menu="matMenu">

            <button mat-menu-item><mat-icon>lock_reset</mat-icon>Change Password</button>
            <button mat-menu-item class="example-icon" (click)="logout()"  aria-label="Example icon-button with lock icon">
                <mat-icon>logout</mat-icon> Logout
            </button>
        </mat-menu>
    </div>
</mat-toolbar>
